import styled from "styled-components/macro";

import {useParams} from "react-router-dom";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import {useFeedback} from "../../store/feedback";
import {useQuery} from "../../utils/router";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import Pagination from "../../components/pagination";
import {useCommunityComments} from "../../api/comment";
import Comment from "../../components/comment";
import {isPseudoCommunity} from "../../store/communites";
import CommunityInfo from "../../components/community_info";

const Comments = styled(({className}) => {

    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);

    const page = parseInt(useQuery().page || '1');
    const {busy, feedbackCh} = useFeedback();
    const {comments} = useCommunityComments(feedbackCh, community, page);

    return (
        <div className={className}>
            <HeaderData title={`Comments in ${community}`} showBrand={false} community={community} community_style={style}/>
            <Header>
                <TopBar page={`Comments`} />
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        <CommunityInfo desktop community={community} />
                    </>
                }
            </Header>
            <SortBar community={community} />
            <Container forceWidth={"slim"}>
                <Wrapper>
                    <Main>
                        {comments.map((comment) => (
                            <Comment
                                key={comment.id}
                                comment={comment}
                                showCommunity={community === 'win' || community === 'all' || community === 'home'}
                                contextual
                                hideComments
                                postAuthor={comment.post_author}
                            />
                        ))}
                        {busy && Array(10).fill(null).map((comment, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <Comment key={index} contextual/>
                        ))}
                    </Main>
                    <Pagination path={`/${community.toLowerCase() === 'win' ? '' : `c/${community}/`}comments?page=`} has_more page={page} />
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={community} />
            </Container>
            <Footer />
        </div>
    );
})`
  ${Main} {
    padding: 4px;
  }

  @media only screen and (max-width: 780px) {
    ${Main} {
      padding: 0;
    }
  }
`;

export default Comments;